import axios from "axios";
import Cookies from "js-cookie";
import { CONFIG } from "../../config";
export const getAllQuizes = async () => {
	try {
		const response = await axios.get(
			`${CONFIG.SCHOOLURL}/quizzes/get-all`
		);
		return response.data;
	} catch (error) {
		return "error";
	}
};

export const getAllQuizesByStudent = async (studentId) => {
	try {
		const authToken = Cookies.get("authToken");
		const response = await axios.get(
			`${CONFIG.SCHOOLURL}/quizzes/my-quizzes`,
			authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
		);
		return response.data;
	} catch (error) {
		return "error";
	}
};

// export const getQuizByParentId = async (id) => {
// 	return await axios.get(`${CONFIG.SCHOOLURL}/quizzes/get-by-parent/${id}`);
//   };

export const getQuizesByParentId = async (quizeId) => {
	try {
		const response = await axios.get(
			`${CONFIG.SCHOOLURL}/quizzes/get-by-parent/${quizeId}`
		);
		return response.data;
	} catch (error) {
		return "error";
	}
};